import { defineStore } from 'pinia'
import { useRequest } from 'composables/useRequest.js'

const CACHE_TTL = 5 * 60 * 1000

export const useAttendeesStore = defineStore('attendees', {
  state: () => ({
    attendees: [],
    fetchedAt: null,
    loading: false,
    error: null,
  }),

  getters: {
    isCacheValid: (state) =>
      state.fetchedAt !== null && Date.now() - state.fetchedAt < CACHE_TTL,
  },

  actions: {
    async fetchIfStale() {
      if (this.isCacheValid && this.attendees.length > 0) return
      await this.fetchAttendees()
    },

    async fetchAttendees() {
      this.loading = true
      this.error = null
      try {
        const { axiosRequest } = useRequest()
        const res = await axiosRequest('GET', '/attendees.json', {}, false)
        if (!res.js_error && res.response.success) {
          this.attendees = res.response.data
          this.fetchedAt = Date.now()
        } else {
          this.error = 'Failed to load attendees.'
        }
      } catch {
        this.error = 'Something went wrong.'
      } finally {
        this.loading = false
      }
    },

    invalidate() {
      this.fetchedAt = null
    },
  },
})
